<template>
  <Dialog ref="dialog" type="refresh" :show="$bus.refreshDialog.show">
    <template v-slot:dialog-content>
      <p class="refresh-tip" v-html="getText"></p>
      <ff-button type="comfirm" @click.native="$bus.refresh($bus.refreshDialog.status)">
        <span class="refresh-btn-text">{{$bus.transify['T_P_CONFIRM']}}</span>
      </ff-button>
    </template>
  </Dialog>
</template>

<script>
import Item from '@/components/common/Item'
import ffButton from '@/components/common/Button.vue'
import Dialog from '@/components/common/Dialog.vue'
export default {
  components: {
    Item,
    ffButton,
    Dialog
  },
  computed: {
    getText () {
      if (this.$bus.refreshDialog.status === 0) { // 免费刷新
        return this.$bus.transify['T_FRESH_NOTYET']
      } else { // 1 付费刷新
        return this.replaceText(this.$bus.transify['T_P_REFRESH_DBCHECK'], ':x', `<span style="font-size: 1.3em; color: #FFDE00; font-weight: 500;">${this.$bus.actInfo.refreshCost}</span>`)
      }
    }
  },
  methods: {
    replaceText (text, source, target) {
      if (text.indexOf(source) > -1) {
        return text.replace(source, `${target}`)
      } else {
        return text
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.refresh-btn-text {
  flex: auto;
  @include px2res(height, 60);
  @include px2res(line-height, 66);
}
.refresh-tip {
  max-width: 90%;
  margin: 0 auto;
  text-align: center;
  line-height: 1;
  @include px2res(font-size, 38);
}
.refresh-tip > span {
  @include px2res(font-size, 46);
  color: #FFDE00;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/refresh/index.vue